import { Grid } from "semantic-ui-react";

import { useTranslation } from "react-i18next";

import earselectProducerId from "astrid-firestore/src/api/organizations/constants/earselectProducerId";
import updateDocument from "astrid-firestore/src/helpers/updateDocument";
import useDocumentDataOnce from "astrid-firestore/src/hooks/useDocumentDataOnce";
import useLoadingValues from "astrid-firestore/src/hooks/useLoadingValues";

import Button from "../../../ui/components/Buttons/Button";
import LoadingContext from "../../../ui/components/LoadingContext/LoadingContext";
import Message from "../../../ui/components/Messages/Message";

import Vendor from "../../../vendors/components/Vendor";

import OrderCosts from "./components/OrderCosts";

export default function OrderDetails({ order, costs, readOnly = false }) {
	const { t } = useTranslation();

	const [[firstParty, secondParty], loading, error] = useLoadingValues(
		useDocumentDataOnce(order.firstParty?.ref),
		useDocumentDataOnce(order.secondParty?.ref),
	);

	const firstPartyVendor = firstParty?.vendors?.[order.firstParty?.vendor?.id] || order.firstParty?.vendor;
	const secondPartyVendor = secondParty?.vendors?.[order.secondParty?.vendor?.id] || order.secondParty?.vendor;

	const recipientVendor = order.expense ? firstPartyVendor : secondPartyVendor;
	const senderVendor = order.expense ? secondPartyVendor : firstPartyVendor;

	const onMarkAsSent = () => {
		updateDocument(order.ref, { sent: true });
	};

	return (
		<LoadingContext data={firstParty} loading={loading} error={error}>
			<Grid celled>
				{!readOnly && order.firstParty?.id === earselectProducerId && (
					<Grid.Row>
						<Grid.Column>
							<Message info header={order.id}>
								{t(
									"includePurchaseOrderIdMessage",
									"Include the purchase order reference in the invoice",
								)}
							</Message>
						</Grid.Column>
					</Grid.Row>
				)}

				<Grid.Row columns={2}>
					{recipientVendor && (
						<Grid.Column>
							<strong>{t("recipient", "Recipient")}</strong>

							<Vendor vendor={recipientVendor} />
						</Grid.Column>
					)}

					{senderVendor && (
						<Grid.Column>
							<strong>{t("sender", "Sender")}</strong>

							<Vendor vendor={senderVendor} />
						</Grid.Column>
					)}
				</Grid.Row>

				<Grid.Row>
					<Grid.Column>
						<OrderCosts costs={costs} order={order} firstParty={firstParty} readOnly={readOnly} />
					</Grid.Column>
				</Grid.Row>

				{!readOnly && !order.sent && (
					<Grid.Row>
						<Grid.Column>
							<Button floated="right" primary onMouseDown={onMarkAsSent}>
								{t("markAsSent", "Mark as sent")}
							</Button>
						</Grid.Column>
					</Grid.Row>
				)}
			</Grid>
		</LoadingContext>
	);
}
